import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable } from 'rxjs';

import { IProfile } from '../../../utils/interfaces/profile';
import { IResponse } from '../../../utils/interfaces/response';
import { ProfileService } from '../profile.service';

export const getAllProfileResolver: ResolveFn<
  Observable<IResponse<IProfile[]>>
> = (route, state) => {
  const profileService = inject(ProfileService);
  return profileService.getAllProfile();
};
